import React from 'react';
import { BrowserRouter ,Routes, Route } from 'react-router-dom';
import InfoUser from '../Pages/UserProfile/InfoUser';
const UserRoutes = () => {
    const UserUrl = "/user";
    return(
        <BrowserRouter>
            <Routes>
                
                <Route path={`/home/212`} element={<InfoUser />} />
            </Routes>
        </BrowserRouter>
    )
}
export default UserRoutes;